/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Srt_LabelInputs */



/**
* | output |
* | --- |
* | "Export SRT File(s)" |
*
* @param {Audio_Description_Export_Srt_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_srt_label = /** @type {((inputs?: Audio_Description_Export_Srt_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Srt_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter le ou les fichiers SRT")
	if (locale === "de") return /** @type {LocalizedString} */ ("SRT-Datei(en) exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta file SRT")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт файла(ов) SRT")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar archivo(s) SRT")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出 SRT 文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("SRT ファイルをエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("SRT फ़ाइलें निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar arquivo(s) SRT")
	return /** @type {LocalizedString} */ ("Export SRT File(s)")
});